/* eslint-disable class-methods-use-this */
import { ModelDto } from '../dtos/model.dto';
import Model from '../models/model';

export default class ModelMapping {
  getModelResponse(data: ModelDto): Model {
    return {
      code: data.codigo,
      apesegCode: data.codigoApeSeg,
      description: data.descripcion,
      alternative: data.alternativo,
      mtcCategory: data.categoriaMtc,
      standard: data.estandar,
    };
  }
  formatModelRequest(data: Model): ModelDto {
    return {
      codigo: data.code,
      descripcion: data.description,
      codigoApeSeg: data.apesegCode,
      estandar: data.standard,
      categoriaMtc: data.mtcCategory === '' ? null : data.mtcCategory,
      alternativo: data.alternative === '' ? null : data.alternative,
    };
  }
}
